import './App.css';
import './components/companyes_ui.css';
import './components/job_tasks_ui.css';
import './components/button_ui.css';
import './components/editors_ui.css';
import { Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import { appRoutes } from './routes';
import Cookies from "js-cookie";
import Footer from './master_root/footer';  
 import Idpage from './pages/idpage'; 
import ScrollToTop from './master_root/ScrollToTop';
import { FaArrowUp } from 'react-icons/fa';  // For arrow icon

import './master_root/statusbar.css';
import CookieConsent from './master_root/CookieConsent';
import Footertearms from './master_root/footer-tearms'; 
function App() {
  
  const [loading, setLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};
 
useEffect(() => {
  const fetchLocationData = async () => {
    try {
      const ipRes = await fetch('https://ipapi.co/json/');
      const ipData = await ipRes.json();

      const usercountryname = ipData.country_name || "no";
      const usercity = ipData.city || "no";
      const userstate = ipData.region || "no";
      const userpostcode = ipData.postal || "no";
      const userphonecode = ipData.country_calling_code ? ipData.country_calling_code.replace("+", "") : "no";
      const useripaddress = ipData.ip || "no";
      let userlatitude = ipData.latitude || "no";
      let userlongitude = ipData.longitude || "no";

      Cookies.set("ipaddres", useripaddress, { expires: 365 });
      Cookies.set("latitude", userlatitude, { expires: 365 });
      Cookies.set("longitude", userlongitude, { expires: 365 });

      Cookies.set("Country", usercountryname, { expires: 365 });
      Cookies.set("City", usercity, { expires: 365 });
      Cookies.set("State", userstate, { expires: 365 });
      Cookies.set("Postcode", userpostcode, { expires: 365 });

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            userlatitude = position.coords.latitude;
            userlongitude = position.coords.longitude;

            try {
              const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${userlatitude},${userlongitude}&key=AIzaSyC3S4_yTEhJsCBzQ76_tIf8FusVUw6Fc3A`
              );
              const geoData = await response.json();
              const useraddress = geoData.results[0]?.formatted_address || "Not Found";
              console.log("📍 Full Address:", useraddress);
            } catch (geoError) {
              console.error("❌ Error with reverse geocoding:", geoError);
            }
          },
          (geoError) => {
            console.error("❌ Error with geolocation access:", geoError);
          }
        );
      } else {
        console.error("❌ Geolocation not supported by browser.");
      }

    } catch (err) {
      console.error("❌ Error fetching IP data:", err);
    }
  };

 fetchLocationData();
}, []);


  useEffect(() => {
    const toggleVisibility = () => {
        if(window.scrollY >10)
        {
            setIsVisible(true);
            const headerElement = document.getElementsByClassName('header')[0]; 
            if (headerElement) {
                headerElement.style.WebkitBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.14)";  
                headerElement.style.MozBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.14)";
                headerElement.style.boxShadow = "0px 5px 5px -4px rgba(0,0,0,0.14)";     
            }
            const statusbarElement = document.getElementsByClassName('status-bar')[0]; 
            if (statusbarElement) {
              statusbarElement.style.WebkitBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.14)";  
              statusbarElement.style.MozBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.14)";
              statusbarElement.style.boxShadow = "0px 5px 5px -4px rgba(0,0,0,0.14)";     
            }
        }
        else{ 
            setIsVisible(false);
            const headerElement = document.getElementsByClassName('header')[0];
            if (headerElement) {
                headerElement.style.WebkitBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.0)";  
                headerElement.style.MozBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.0)";
                headerElement.style.boxShadow = "0px 5px 5px -4px rgba(0,0,0,0.0)";   
            }
            const statusbarElement = document.getElementsByClassName('status-bar')[0]; 
            if (statusbarElement) {
              statusbarElement.style.WebkitBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.0)";  
              statusbarElement.style.MozBoxShadow = "0px 5px 5px -4px rgba(0,0,0,0.0)";
              statusbarElement.style.boxShadow = "0px 5px 5px -4px rgba(0,0,0,0.0)";     
            }
        }
    };
    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
}, []);


  return (
    <div >   
       
    <ScrollToTop />
    {isVisible && (
                <button onClick={scrollToTop} className="scroll-to-top-btn" title="Scroll to top">
                    <FaArrowUp />
                </button>
            )}
{window.innerWidth > 768 ? (
  <CookieConsent />
) : null}
      <Routes>
  
  {appRoutes.map(({ path, element }, i) => (
    <Route key={i} path={path} element={element} />
  ))}
  <Route path="/:id" element={<Idpage />} />
</Routes>
 
     
      <Footertearms/>
   
    </div>
  );
}

export default App;
